import type { IConfig } from './configModel';

import {
  Conversation,
  Dialogue,
  Presence,
  Recording,
  Reports,
  UserInput,
  View,
  Vocalise,
  Vision,
  FeatureFlags,
  VoiceToText,
  Flows,
  System,
  Microphone,
} from './features';

export const defaultConfiguration: IConfig = {
  revision: 0,
  conversation: Conversation.defaultConfig,
  dialogue: Dialogue.defaultConfig,
  presence: Presence.defaultConfig,
  recording: Recording.defaultConfig,
  reports: Reports.defaultConfig,
  userInput: UserInput.defaultConfig,
  view: View.defaultConfig,
  vocalise: Vocalise.defaultConfig,
  vision: Vision.defaultConfig,
  featureFlags: FeatureFlags.defaultConfig,
  voiceToText: VoiceToText.defaultConfig,
  flows: Flows.defaultConfig,
  system: System.defaultConfig,
  microphone: Microphone.defaultConfig,
};

type MergeHandlerMap<T> = {
  [P in keyof T]: (
    target: Partial<T[P]>,
    source: Partial<T[P]>
  ) => Partial<T[P]>;
};

export const customMergeHandlers: Partial<MergeHandlerMap<IConfig>> &
  Record<string, (target?: unknown, source?: unknown) => unknown> = {
  voiceToText: VoiceToText.mergeConfig,
  dialogue: Dialogue.mergeConfig,
};
